<template>
  <div>
    <span class="text-dark opacity-50">
      <span>Category</span>
      <span class="px-1">/</span>
      <span>{{ product.categoryName }}</span>
      <span class="px-1">/</span>
    </span>
    <span class="text-blue">{{ product.name }}</span>
  </div>
</template>
<script>
export default {
  name: 'Breadcrumb',
  props: {
    product: {
      type: Object
    }
  }
}
</script>
